module.exports = __webpack_public_path__ + "static/media/blueinsect_6.0d5fcabb.webp";